export default __webpack_public_path__ + "static/media/kwid-colour-3.83a51ed0.jpg";